import React, { Fragment } from 'react';

import { Button } from 'react-bootstrap';
import { Grid } from 'jrgrid';
import { pageRequests } from '../../Receiving/api';
import { userRequestColumns } from '../utils';

export const UserRequests = (props: any) => {
    const Wrapper = ({ condition, wrapper, children }) => {
    return condition ? wrapper(children) : children;
  };
  
  const isPC = props.user.currentRole.roleId === 10 || props.user.currentRole.roleId === 3
  // roles.map((role) => {
  //   return role.id === 3 || role.id === 10
  // }).length > 0

// React.useEffect(() => {
//   console.log(props.user)
// }, [])

  // console.log('isPC: ', isPC)

  const filter = props.dept
    ? [
        {
          id: 'requestingDepartment',
          type: 'string',
          operand: 'and',
          isLike: true,
          value: props.dept.Name,
        },
      ]
    : isPC ? [
      {
        id: 'requestingDepartment',
        type: 'string',
        operand: 'and',
        isLike: true,
        value: props.user.currentRole.department.Name
      }
    ]: [
        {
          id: 'requestorEmail',
          type: 'string',
          operand: 'and',
          isLike: true,
          value: props.user.email,
        },
      ];

  return (
    <Fragment>
      <Wrapper condition={props.user.currentRole.roleName === 'Guest'} wrapper={(children) => <div className='m-5'>{children}</div>}>
        <div className='m-3'>
          <div className='row justify-content-start'>
            <div className='col-sm-6'>
              <h2>{props.title ? props.title : (isPC ? `Department Requests: ` : 'Your Requests: ')}</h2>
            </div>
            <div className='col-sm-6 '>
              <Button  variant='info' className='float-right mt-2 mb-2' href='/receiving/create'>
                Create New Request
              </Button>
            </div>
          </div>
          <Grid
            amount={props.user.currentRole.roleName === 'Guest' ? 10 : 3}
            columns={userRequestColumns}
            query={pageRequests}
            queryName='pageRequests'
            defaultSortField='id'
            globalFilters={filter}
            queryTag={props.dept ? 'homepage dept' : 'homepage user'}
          />
        </div>
      </Wrapper>
    </Fragment>
  );
};
